import dayjs from "dayjs";
import {CreditReportingType} from "../declarations";

export function getDaysUntilCreditReport(
  lastReportType: CreditReportingType | undefined,
  nextRepostDate: string | undefined
): number | undefined {
  if (lastReportType === "not_reported" && nextRepostDate) {
    return dayjs(nextRepostDate).diff(dayjs(), "day");
  }
  return;
}

export const isInRiskOfBeingReported = (
  lastReportType: CreditReportingType | undefined,
  nextRepostDate: string | undefined
): boolean => Boolean(nextRepostDate && lastReportType === "not_reported");

export const isAlreadyReported = (lastReportType: CreditReportingType | undefined): boolean =>
  lastReportType === "reported";
